
            const data = {"name":"icon-plus-small","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M4.4 17.7a1.7 1.7 0 110-3.4h23.2a1.7 1.7 0 110 3.4H4.4z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M17.7 27.6a1.7 1.7 0 11-3.4 0V4.4a1.7 1.7 0 113.4 0v23.2z\"/>"}}
        
                module.exports = data
                